import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { keywordReplyList, keywordReplyDelete } from "@/api/customerCenter/customerCenter";
import addKeyWordsItem from "./components/addKeyWordsItem.vue";
export default {
  name: "keyWordSearch",
  components: {
    addKeyWordsItem: addKeyWordsItem
  },
  mixins: [tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      paramsData: {
        page_size: 10,
        page: 1,
        keyword: ''
      },
      gameAllList: [],
      tableData: [],
      total: 0,
      page: 1
    };
  },
  created: function created() {
    this.getGameData();
  },
  methods: {
    getGameData: function getGameData(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var query;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch("d2admin/game/GameList");

              case 2:
                query = _context.sent;
                _this.gameAllList = query || [];

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    sizeChange: function sizeChange(e) {
      this.paramsData.page_size = e;
      this.searchClick(1);
    },
    searchClick: function searchClick(e) {
      var _this2 = this;

      this.paramsData.page = e;
      var searchData = JSON.parse(JSON.stringify(this.paramsData));
      this.reqLoading = true;
      keywordReplyList(searchData).then(function (res) {
        if (res.code == 200) {
          res.data.data.forEach(function (item) {
            var game = _this2.gameAllList.find(function (b) {
              return b.game_mark == item.game;
            });

            item.game_name = game ? game.game_name : '';
          });
          _this2.tableData = res.data.data || [];
          _this2.total = res.data.total;
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },
    handleDelete: function handleDelete(id) {
      var _this3 = this;

      this.$confirm("此操作将删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                keywordReplyDelete({
                  id: id
                }).then(function (res) {
                  if (res.code == 200) {
                    _this3.searchClick(_this3.paramsData.page);

                    _this3.$message({
                      type: "success",
                      message: '删除成功'
                    });
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    }
  }
};